import {CancelRules, CostBreakdownName, Order, OrderStatus} from '@yandex-taxi/js-integration-api'
import {DraftAddress} from '@yandex-taxi/react-integration-api'

import {Tariff} from './consts'

export const toPascalCase = (s: string) => {
  s = s.charAt(0).toUpperCase() + s.slice(1)

  return s.replace(/([-_][a-z])/gi, ($1: string) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}

export const formatWaitingMessage = (message: string): string =>
  message.includes('через') ? `Прибудет примерно ${message}` : message

export type DisplayableOrder = {
  id: string
  status: OrderStatus
  tariff: Tariff
  cost: string
  source: string
  destination: string
  cancelDisabled: boolean
  history: boolean
  cancelRules?: CancelRules
}

export const activeOrderToDisplayable = (order: Order): DisplayableOrder => {
  const route = order.request.route

  return {
    id: order.orderid,
    status: order.status,
    tariff: order.request.class as Tariff,
    cost: order.cost_message_details.cost_breakdown?.find(c => c.display_name === CostBreakdownName.COST)
      ?.display_amount,
    source: route[0].short_text,
    destination: route[route.length - 1].short_text,
    cancelDisabled: order.cancel_disabled,
    cancelRules: order.cancel_rules,
    history: false,
  }
}

export const historyOrderToDisplayable = (order): DisplayableOrder => ({
  id: order.order_id,
  status: order.taxi_status as OrderStatus,
  tariff: order.tariff_internal_name,
  cost: `${order?.payment?.cost}руб.`,
  source: order.route.source,
  destination: order.route.destination,
  cancelDisabled: true,
  history: true,
})
export const parseValidAddresses = (route: DraftAddress[]) =>
  route.filter(item => item.address?.point || item.address?.geoObject)

export const canAddAddress = (maxRoutePoints: number, points: DraftAddress[]) => points.length < maxRoutePoints
